import React from 'react';
import styles from './Hint.module.scss';

export default function Hint({ children }) {
  return <span className={styles.hint}>{children}</span>;
}
